import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { WithCustomerPortalApi } from 'core/customerPortalApi';
import { getApiUrl } from '#lib/utils/environment';

type useSignedUrlProps = {
  fileName: string;
  id: string;
};

type responseType = {
  url: string;
};

export const useSignedUrl = WithCustomerPortalApi<
  responseType,
  UseMutationResult<responseType['url'], Error, useSignedUrlProps>,
  undefined
>(
  (fetchFn) =>
    useMutation<responseType['url'], Error, useSignedUrlProps>({
      mutationFn: async ({ fileName, id }) => {
        const url = new URL(getApiUrl() + '/signed-upload-url');

        const data = await fetchFn({
          url,
          options: {
            method: 'POST',
            body: JSON.stringify({ fileName, fileId: id }),
          },
        });

        return data.url;
      },
    }),
  { hookName: 'useSignedUrl' },
);
